"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_SINISTRI_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetSinistri,
    skipImportingInCMS: false,
}, {
    tpdBoxAiutoSinistri: {
        __mfeName__: "tpdBoxAiutoSinistri",
        devClientPort: 6050,
        devServerPort: 6150,
    },
    tpdBoxAltriCasiSinistri: {
        __mfeName__: "tpdBoxAltriCasiSinistri",
        devClientPort: 6055,
        devServerPort: 6155,
    },
    tpdBoxContareSinistri: {
        __mfeName__: "tpdBoxContareSinistri",
        devClientPort: 6053,
        devServerPort: 6153,
    },
    tpdBoxDubbiSinistri: {
        __mfeName__: "tpdBoxDubbiSinistri",
        devClientPort: 6049,
        devServerPort: 6149,
    },
    tpdBoxIncidenteSinistri: {
        __mfeName__: "tpdBoxIncidenteSinistri",
        devClientPort: 6051,
        devServerPort: 6151,
    },
    tpdBoxVisualizzaSinistriWidget: {
        __mfeName__: "tpdBoxVisualizzaSinistriWidget",
        devClientPort: 6056,
        devServerPort: 6156,
    },
    tpdConfermaInvioSinistri: {
        __mfeName__: "tpdConfermaInvioSinistri",
        devClientPort: 6059,
        devServerPort: 6159,
    },
    tpdDenunceInviateSinistri: {
        __mfeName__: "tpdDenunceInviateSinistri",
        devClientPort: 6048,
        devServerPort: 6148,
    },
    tpdDueVeicoliSinistri: {
        __mfeName__: "tpdDueVeicoliSinistri",
        devClientPort: 6054,
        devServerPort: 6154,
    },
    tpdLaTuaAgenziaSinistriWidget: {
        __mfeName__: "tpdLaTuaAgenziaSinistriWidget",
        devClientPort: 6067,
        devServerPort: 6167,
    },
    tpdMenuSinistri: {
        __mfeName__: "tpdMenuSinistri",
        devClientPort: 6047,
        devServerPort: 6147,
    },
    tpdCardPassiviModificaVersioneControparteSinistri: {
        __mfeName__: "tpdCardPassiviModificaVersioneControparteSinistri",
        devClientPort: 6065,
        devServerPort: 6165,
    },
    tpdCardPassiviNegazioneSinistroWidget: {
        __mfeName__: "tpdCardPassiviNegazioneSinistroWidget",
        devClientPort: 6061,
        devServerPort: 6161,
    },
    tpdPreaperturaStepsSinistri: {
        __mfeName__: "tpdPreaperturaStepsSinistri",
        devClientPort: 6063,
        devServerPort: 6163,
    },
    tpdCpmPrenotazioneVisitaSinistri: {
        __mfeName__: "tpdCpmPrenotazioneVisitaSinistri",
        devClientPort: 6062,
        devServerPort: 6162,
    },
    tpdRiepilogoDenunciaSinistri: {
        __mfeName__: "tpdRiepilogoDenunciaSinistri",
        devClientPort: 6089,
        devServerPort: 6189,
    },
    tpdCpmRiepilogoVisitaSinistri: {
        __mfeName__: "tpdCpmRiepilogoVisitaSinistri",
        devClientPort: 6066,
        devServerPort: 6166,
    },
    tpdTargheSinistriWidget: {
        __mfeName__: "tpdTargheSinistriWidget",
        devClientPort: 6064,
        devServerPort: 6164,
    },
    tpdTrackingSinistriWidget: {
        __mfeName__: "tpdTrackingSinistriWidget",
        devClientPort: 6057,
        devServerPort: 6157,
    },
    tpdUltimoSinistroWidget: {
        __mfeName__: "tpdUltimoSinistroWidget",
        devClientPort: 6300,
        devServerPort: 6400,
    },
});
exports.WIDGET_SINISTRI_REMOTES_SETTINGS = settings;
